/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable react/self-closing-comp */
/* eslint-disable react/no-unknown-property */
// @flow
import { useEffect } from 'react';
import type { BlokComponentPropsType } from '../types';

export type PropsType = BlokComponentPropsType<{
  key: string
}>;

const SATORI_ID = '-_-satori_creative-_-';

function SatoriCode({ blok: { key } }: PropsType) {
  useEffect(() => {
    // we make sure we load this on demand and never SSR it
    // We also have to make sure we clean up
    const node = document.createElement('script');
    node.type = 'text/javascript';
    node.src = 'https://delivery.satr.jp/js/creative_set.js';
    node.id = SATORI_ID;
    node.async = true;
    node.dataset.key = key;
    node.dataset.immediately = 'true';
    if (document.body) document.body.appendChild(node);
    return () => {
      // cleanup the satori script inserted items to ensure
      // the next time is instantiated correctly
      node.remove();
      // eslint-disable-next-line no-underscore-dangle
      window.__SatoriInitializedCreativeKeys = [];
    };
  }, []);
  return <div id="satori__creative_container" />;
}

export default SatoriCode;
